import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";



export const getGroupClass = (userId, token, groupClassId) => {
    return fetch(`${API}/groupclass/${userId}/${groupClassId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const createGroupClass=(userId,token,payload)=>{
    return fetch(`${API}/groupclass/create/${userId}`,{
        method: "POST",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const updateGroupClass=(userId,token,groupClassId,payload)=>{
    return fetch(`${API}/groupclass/update/${userId}/${groupClassId}`,{
        method: "PUT",
        headers:{
          Accept: "application/json",
          "Content-type":"application/json",
          Authorization: `Bearer ${token}`
      },
      body:JSON.stringify(payload)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const removeGroupClass=(userId,token,groupClassId)=>{
    return fetch(`${API}/groupclass/delete/:userId/:groupClassId`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getAllGroupClass=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/groupclasses/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};



export const getGroupClassCount=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/groupclass/count/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

